// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"c5d4b87a0e8d945b","table":"ecbaa630b7a4cc53","wrapper":"e5ac8f3d60cff5fd","edit":"cdee3e6268b3fed0","editColumn":"_253efe81ee2862bd"};